import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useDocumentSEO } from "@/hooks/useDocumentSEO";

export default function NotFoundPage() {
  useDocumentSEO({
    title: "Sayfa Bulunamadı",
    description: "Aradığınız içerik taşınmış veya kaldırılmış olabilir.",
  });
  return (
    <section
      data-testid="not-found-page"
      className="relative bg-navy text-white min-h-[70vh] flex items-center"
    >
      <div className="absolute inset-0 blueprint-grid opacity-40" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-8 w-full">
        <div className="md:col-span-8">
          <div className="overline text-gold mb-6">Hata 404</div>
          <h1 className="font-heading text-5xl md:text-7xl font-light tracking-tight leading-none">
            Sayfa bulunamadı.
          </h1>
          <p className="mt-6 max-w-lg text-white/70 leading-relaxed font-light">
            Aradığınız içerik taşınmış veya kaldırılmış olabilir. Ana sayfaya
            dönerek gezinmeye devam edebilirsiniz.
          </p>
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="mt-10 inline-flex items-center gap-3 bg-gold hover:bg-gold-hover text-white px-7 py-3.5 text-[12.5px] tracking-widest uppercase font-medium transition-colors group"
          >
            Ana Sayfaya Dön
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </section>
  );
}
